import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { dict } from "@/lib/i18n";

const LANG_KEY = "ncl_lang";
const I18nCtx = createContext({ lang: "es", t: dict.es, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem(LANG_KEY);
      return saved === "en" ? "en" : "es";
    } catch (_) { return "es"; }
  });

  useEffect(() => {
    try {
      localStorage.setItem(LANG_KEY, lang);
      document.documentElement.lang = lang;
    } catch (_) {}
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "es"), []);
  const toggle = useCallback(() => setLangState((l) => (l === "es" ? "en" : "es")), []);

  const value = useMemo(() => ({ lang, t: dict[lang], setLang, toggle }), [lang, setLang, toggle]);
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export function useI18n() { return useContext(I18nCtx); }
